import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData } from "../../utils/getData";

export const getInitiatives = createAsyncThunk(
  "initiatives/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const {
        page = 1,
        limit = 20,
        status,
        priority,
        owner_id,
        search,
        sort_by = "createdAt",
        sort_order = "DESC",
      } = params;

      let url = `${process.env.REACT_APP_BASE_URL}api/initiatives?page=${page}&limit=${limit}&sort_by=${sort_by}&sort_order=${sort_order}`;

      if (status) url += `&status=${status}`;
      if (priority) url += `&priority=${priority}`;
      if (owner_id) url += `&owner_id=${owner_id}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;

      const response = await getData(url);
      if (!response || !response.success) {
        return rejectWithValue(response?.message || "Failed to fetch initiatives");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch initiatives");
    }
  }
);
